import { useAppSelector } from '../state';
import { selectLinkTokenPayload } from '../state/slices/slice-link-params';
var useLinkSolution = function () {
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var linkSolution = linkTokenPayload.solution;
    var linkFeatures = linkTokenPayload.features;
    var isLinkFeatureEnabled = function (feature) {
        return linkFeatures.includes(feature);
    };
    return {
        linkSolution: linkSolution,
        linkFeatures: linkFeatures,
        isLinkFeatureEnabled: isLinkFeatureEnabled,
    };
};
export default useLinkSolution;
